import React from 'react';
import NavBar from '../components/Navbar/NavBar';
import CV from '../images/cv.svg'
import SectionHeading from './SectionHeading';

const Biography = () => {
    return (
        <div id="biography" className="bg-white pt-24 pb-16 md:pb-20">
            <NavBar />
            <section data-aos="zoom-in-down" className="container-app">
                <SectionHeading eyebrow="Tentang Kami" title="Portofolio" />

                <div className="flex flex-col items-center justify-center">
                    <p className="max-w-3xl mx-auto text-center text-slate-600 leading-relaxed">
                        PT. BERANI SETIA WASPADA adalah perusahaan terpercaya yang bergerak di bidang jasa keamanan dan cleaning service,
                        dengan pengalaman luas dalam menangani kebutuhan keamanan di berbagai sektor seperti perkantoran, mal, perumahan, rumah sakit, perkebunan, pabrik, dan pergudangan.
                        Kami mengedepankan kualitas sumber daya manusia yang terlatih dan berintegritas tinggi, didukung oleh teknologi terkini untuk menciptakan sistem keamanan yang terintegrasi dan efektif.
                        Dengan komitmen untuk terus meningkatkan standar layanan, kami hadir sebagai mitra andal dalam memberikan solusi keamanan dan kebersihan yang prima.
                        <br />
                        <br />
                        Visi kami adalah menjadi penyedia jasa keamanan dan cleaning service terbaik di Indonesia, dengan misi menyediakan personil yang profesional, siap melayani, dan membangun kemitraan yang harmonis dengan klien.
                        Tujuan utama kami adalah menciptakan lingkungan kerja yang aman, nyaman, dan kondusif bagi setiap klien. Dengan motto "Kenyamanan dan keamanan Anda adalah prioritas kami," PT. BERANI SETIA WASPADA siap menjadi pilihan utama dalam memberikan layanan berkualitas tinggi yang berkelanjutan.
                    </p>

                    <div className="flex items-center justify-center mt-10 w-full">
                        <img
                            alt="Ilustrasi profil perusahaan"
                            className="rounded-2xl shadow-card w-full max-w-md lg:max-w-2xl"
                            src={CV}
                        />
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Biography;
